import React, { lazy } from "react";
import { ContractAnalyzerProvider } from "@features/contractAnalyzer/providers";
import { CashflowAnalyzerProvider } from "@providers";
import { WithFeatureFlagRoute, withSuspense } from "../routes";

const ContractAnalyzerPage = lazy(() =>
  import("@features/contractAnalyzer/ContractAnalyzerPage.tsx").then(
    (module) => ({
      default: module.ContractAnalyzerPage,
    })
  )
);

const CashflowAnalyzerPage = lazy(() =>
  import("@features/cashflowAnalyzer/CashflowAnalyzerPage.tsx").then(
    (module) => ({
      default: module.CashflowAnalyzerPage,
    })
  )
);

export default [
  {
    path: "contract-analyzer",
    element: (
      <WithFeatureFlagRoute featureFlag="CONTRACT_ANALYZER">
        <ContractAnalyzerProvider>
          {withSuspense(ContractAnalyzerPage)}
        </ContractAnalyzerProvider>
      </WithFeatureFlagRoute>
    ),
  },
  {
    path: "cashflow-analyzer",
    element: (
      <WithFeatureFlagRoute featureFlag="CASHFLOW_ANALYZER">
        <CashflowAnalyzerProvider>
          {withSuspense(CashflowAnalyzerPage)}
        </CashflowAnalyzerProvider>
      </WithFeatureFlagRoute>
    ),
  },
];
